<template>
    <div>
        <b-alert show variant="warning">
            {{
                $t(
                    "Random Chat is only supported from the browser. Please open in your web browser to continue."
                )
            }}

            <div class="mt-3">
                <font-awesome-icon icon="fa-duotone fa-info-circle" />
                {{
                    $t(
                        "Your session will not start until you join from the browser."
                    )
                }}
            </div>

            <div class="text-center branded py-3">
                <font-awesome-icon icon="fa-light fa-arrow-down" size="2x" />
            </div>

            <b-btn
                v-if="url"
                @click="openBrowser"
                variant="primary"
                size="lg"
                pill
                block
            >
                <font-awesome-icon
                    icon="fa-duotone fa-arrow-up-right-from-square"
                />
                {{ $t("Open Random Chat in Browser") }}
            </b-btn>

            <div class="mt-3">
                <b-btn
                    v-if="url"
                    @click="copyUrl"
                    variant="link"
                    size="sm"
                    pill
                    block
                >
                    {{ $t("Copy Random Chat URL") }}
                </b-btn>
            </div>
        </b-alert>
    </div>
</template>

<script>
import { mapState } from "vuex";
import copy from "clipboard-copy";

export default {
    data() {
        return {
            url: null,
        };
    },
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    async mounted() {
        try {
            const { data } = await this.api.post("/randomChat/url", {
                userId: this.onboardingUser?.id,
            });
            if (data?.url) {
                this.url = data.url;
            }
        } catch (e) {
            this.url = null;
        }
    },
    methods: {
        openBrowser() {
            if (!this.url) return;
            this.$store.dispatch("system/openBrowser", this.url);
        },
        copyUrl() {
            if (!this.url) return;
            copy(this.url);
        },
    },
};
</script>
